import { gql } from 'graphql-request';

const FacilityFragment = gql`
  fragment Facilities on FacilityBlock {
    blockType
    title
    ctaShowMore
    ctaShowLess
    facilityItems {
      id
      ... on FacilityChooserBlock {
        name
        icon
      }
      ... on FacilityItemBlock {
        name
        icon
      }
    }
  }
`;

/**
 * Services and the Facility block are similar only difference is We call
 * Facility in accommodation homepage and Service in Partner homepage.
 */
const FacilityAsServiceFragment = gql`
  fragment ServiceFacility on ServicesBlock {
    blockType
    title
    ctaShowMore
    ctaShowLess
    facilityItems: serviceItems {
      id
      ... on ServiceItemBlock {
        name
        icon
      }
    }
  }
`;

export default FacilityFragment;
export { FacilityAsServiceFragment };
